export default __webpack_public_path__ + "static/media/Join-Button.f75eeec0.svg";